export const en = {
  title: "Connect to Hotspot",
  verificationTitle: "Choose Verification Method",
  methods: {
    sms: {
      label: "Verify with SMS",
      firstName: {
        label: "First Name",
        placeholder: "Enter your first name"
      },
      lastName: {
        label: "Last Name",
        placeholder: "Enter your last name"
      },
      phone: {
        label: "Phone Number",
        placeholder: "539 XXX XX XX"
      }
    },
    tc: {
      label: "Turkish ID",
      firstName: {
        label: "First Name",
        placeholder: "Enter your first name"
      },
      lastName: {
        label: "Last Name",
        placeholder: "Enter your last name"
      },
      idNumber: {
        label: "Turkish ID Number",
        placeholder: "11111111111"
      },
      birthYear: {
        label: "Birth Year",
        placeholder: "1990"
      }
    },
    whatsapp: {
      label: "WhatsApp",
      firstName: {
        label: "First Name",
        placeholder: "Enter your first name"
      },
      lastName: {
        label: "Last Name",
        placeholder: "Enter your last name"
      },
      phone: {
        label: "WhatsApp Number",
        placeholder: "539 XXX XX XX"
      }
    },
    telegram: {
      label: "Telegram",
      inputLabel: "Telegram Username",
      placeholder: "@username"
    },
    login: {
      label: "Username / Password",
      username: {
        label: "Username",
        placeholder: "Enter your username"
      },
      password: {
        label: "Password",
        placeholder: "Enter your password"
      }
    }
  },
  errors: {
    required: "This field is required"
  },
  buttons: {
    submit: "Connect",
    language: "Türkçe",
    sendPin: "Send PIN",
    verifyPin: "Verify PIN"
  },
  socialMedia: {
    follow: "Follow Us",
    instagram: "Follow on Instagram",
    facebook: "Follow on Facebook",
    twitter: "Follow on Twitter"
  },
  businessInfo: {
    welcome: "Welcome",
    openHours: "Working Hours: 09:00 - 23:00",
    address: "Address: Example Street No:123",
    phone: "Phone: +90 212 XXX XX XX"
  }
}; 